import React, { Fragment, useCallback } from 'react';
import VerificationTypeTestContainer from './VerificationTypeTestContainer';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getInt } from '../../../../../utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const VerificationTestFormulaRoute = props => {
  const historyContext = useHistoryWithContext();
  const verificationTypeId = props.match.params.verificationTypeId && getInt(props.match.params.verificationTypeId);

  const handleRedirect = useCallback(
    verificationTypeId => {
      historyContext.push(`/verificationTypes/${verificationTypeId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <VerificationTypeTestContainer onRedirect={handleRedirect} verificationTypeId={verificationTypeId} />
    </Fragment>
  );
};

VerificationTestFormulaRoute.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(withRouter(VerificationTestFormulaRoute));
